import Affiliate from './Affiliate';

export default Affiliate;
